import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import PrivateRoute from "./auth/PrivateRoute";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import MainLayout from './layout/MainLayout';
import Profile from './pages/Profile';
import { TextProvider } from './context/TextContext';
import GetDays from './pages/GetDays';
import ClassRooms from './pages/ClassRooms';
import DayAbsences from './pages/DayAbsences';
import AdminPanel from './components/AdminPanel/AdminPanel';
import SchoolList from './components/SchoolList/SchoolList';
import CreateSchool from './components/CreateSchool/CreateSchool';
import UserslList from './components/UsersList/UserslList';
import StudentsOfClassroom from './pages/StudentsOfClassroom';
import AbsencesOfStudent from './components/AbsencesOfStudent/AbsencesOfStudent';

function App() {
  return (
    <TextProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>

            {/* Login بدون قالب */}
            <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/create-school" element={<CreateSchool />} />

            {/* صفحات داخل Layout */}
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <MainLayout />
                </PrivateRoute>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="/" element={<ClassRooms />} />
              <Route path="/days" element={<GetDays />} />
              <Route path="/classrooms" element={<ClassRooms />} />
              <Route path="/day-absences" element={<DayAbsences />} />
              <Route path="/student-absences" element={<AbsencesOfStudent />} />
              <Route path="/studentsOfClassroom" element={<StudentsOfClassroom />} />
              <Route path="/admin/schools" element={<SchoolList />} />
              <Route path="/admin/users" element={<UserslList />} />
              <Route path="/users" element={<UserslList />} />
            </Route>

          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </TextProvider>
  );
}

export default App;
